import React from "react";
import "./DashboardNavbar.css";

export default function DashboardNavbar({
  onRealizado,
  onPago,
  onCancelado,
  onFalta,
  disabled = false,
}) {
  return (
    <div className="DashboardNavbar-container">
      <button
        className="DashboardNavbar-button "
        onClick={onRealizado}
        disabled={disabled}
      >
        Realizado
      </button>

      <button
        className="DashboardNavbar-button"
        onClick={onPago}
        disabled={disabled}
      >
        Pago
      </button>

      <button
        className="DashboardNavbar-button"
        onClick={onCancelado}
        disabled={disabled}
      >
        Cancelado
      </button>

      <button
        className="DashboardNavbar-button"
        onClick={onFalta}
        disabled={disabled}
      >
        Falta
      </button>
    </div>
  );
}
